export enum SSLKeyMeta {
  MODEL = "sslkey",
  PK = "id",
}
